// Types de notifications
export const NOTIFICATION_TYPES = {
  NEW_REQUEST: 'new_request',
  STATUS_CHANGE: 'status_change',
  COMMENT_ADDED: 'comment_added',
  SCHEDULED_INTERVENTION: 'scheduled_intervention',
  INTERVENTION_REMINDER: 'intervention_reminder',
  REQUEST_COMPLETED: 'request_completed',
  FEEDBACK_REQUESTED: 'feedback_requested',
  FEEDBACK_RECEIVED: 'feedback_received'
};

// Traductions des types de notifications
export const NOTIFICATION_TYPE_TRANSLATIONS = {
  [NOTIFICATION_TYPES.NEW_REQUEST]: 'Nouvelle demande',
  [NOTIFICATION_TYPES.STATUS_CHANGE]: 'Changement de statut',
  [NOTIFICATION_TYPES.COMMENT_ADDED]: 'Nouveau commentaire',
  [NOTIFICATION_TYPES.SCHEDULED_INTERVENTION]: 'Intervention planifiée',
  [NOTIFICATION_TYPES.INTERVENTION_REMINDER]: 'Rappel d\'intervention',
  [NOTIFICATION_TYPES.REQUEST_COMPLETED]: 'Demande terminée',
  [NOTIFICATION_TYPES.FEEDBACK_REQUESTED]: 'Feedback demandé',
  [NOTIFICATION_TYPES.FEEDBACK_RECEIVED]: 'Feedback reçu'
};

// Statuts de notification
export const NOTIFICATION_STATUS = {
  UNREAD: 'unread',
  READ: 'read'
};

// Fonction pour créer un objet notification
export const createNotification = ({
  type,
  workRequestId,
  serviceId,
  message,
  details = {}
}) => ({
  type,
  workRequestId,
  serviceId,
  message,
  details,
  status: NOTIFICATION_STATUS.UNREAD,
  createdAt: new Date(),
  readAt: null
});
